module.exports = __webpack_public_path__ + "img/logo.bbf20068.png";